import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Badge } from "reactstrap";

const compacto = (n) => new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 }).format(n || 0);
const pesos = (n) => `$${compacto(n)}`;
const entero = (n) => new Intl.NumberFormat("en-US").format(n || 0);
const corta = (f) => {
  const [, m, d] = String(f).split("-");
  return `${d}/${m}`;
};
const colorEstado = { Conectada: "success", Error: "danger" };

// Piezas vendidas por dia: barras apiladas Full + Drop con el total arriba
function GraficaVentas({ serie }) {
  const [activa, setActiva] = useState(null);
  const [tabla, setTabla] = useState(false);
  const maximo = Math.max(1, ...serie.map((d) => d.full + d.drop));
  const alto = (n) => (n ? Math.max(3, (n / maximo) * 145) : 0);
  if (tabla)
    return (
      <>
        <Table size="sm" borderless>
          <thead>
            <tr>
              <th>Dia</th>
              <th style={{ textAlign: "right" }}>Full</th>
              <th style={{ textAlign: "right" }}>Drop</th>
              <th style={{ textAlign: "right" }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {serie.map((d) => (
              <tr key={d.fecha}>
                <td>{corta(d.fecha)}</td>
                <td align="right">{entero(d.full)}</td>
                <td align="right">{entero(d.drop)}</td>
                <td align="right">{entero(d.full + d.drop)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="intg-leyenda">
          <button className="intg-enlace" onClick={() => setTabla(false)}>
            Ver grafica
          </button>
        </div>
      </>
    );
  return (
    <>
      <div className="intg-grafica">
        {serie.map((d) => (
          <div key={d.fecha} className="intg-col" onMouseEnter={() => setActiva(d.fecha)} onMouseLeave={() => setActiva(null)}>
            {activa === d.fecha ? (
              <div className="intg-tooltip">
                {corta(d.fecha)} · Full {entero(d.full)} · Drop {entero(d.drop)}
              </div>
            ) : null}
            <div className="intg-col-total">{compacto(d.full + d.drop)}</div>
            {d.drop ? <div className="intg-seg arriba" style={{ height: alto(d.drop), background: "var(--intg-drop)" }} /> : null}
            {d.full ? <div className={`intg-seg ${d.drop ? "" : "arriba"}`} style={{ height: alto(d.full), background: "var(--intg-full)" }} /> : null}
          </div>
        ))}
      </div>
      <div className="intg-ejex">
        {serie.map((d) => (
          <span key={d.fecha}>{corta(d.fecha)}</span>
        ))}
      </div>
      <div className="intg-leyenda">
        <span>
          <span className="intg-punto" style={{ background: "var(--intg-full)" }} /> Full
        </span>
        <span>
          <span className="intg-punto" style={{ background: "var(--intg-drop)" }} /> Drop
        </span>
        <button className="intg-enlace" onClick={() => setTabla(true)}>
          Ver tabla
        </button>
      </div>
    </>
  );
}

function PanelMeli({ URL, headers, irA, alCargar }) {
  const [d, setD] = useState(null);
  const [fallo, setFallo] = useState("");

  useEffect(() => {
    axios
      .get(`${URL}Panel`, { headers })
      .then((r) => {
        setD(r.data);
        if (alCargar) alCargar(r.data);
      })
      .catch((e) => setFallo(e?.response?.data?.message || "No se pudo cargar el panel"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (fallo) return <div className="intg-vacio">{fallo}</div>;
  if (!d) return <div className="intg-vacio">Cargando...</div>;

  const porRevisar = d.sinAlta.porDarDeAlta + d.noCapturadas;
  const stock = d.cuentas.filter((c) => c.modo === "Lectura y escritura" && c.sincronizaStock !== "No").length;

  return (
    <>
      {d.fallas.length ? (
        <button className="intg-kpi" style={{ width: "100%", marginBottom: 12, borderColor: "#fbbf24", background: "#fffbeb" }} onClick={() => irA("bitacora")}>
          <span style={{ color: "#92400e", fontSize: 13 }}>
            <i className="fas fa-exclamation-triangle"></i> Mercado Libre rechazo consultas en las ultimas 24 horas:{" "}
            {d.fallas.map((f) => `${entero(f.n)} de ${f.tipo}`).join(" · ")}. Ver bitacora
          </span>
        </button>
      ) : null}
      <div className="intg-kpis">
        <div className="intg-kpi">
          <div className="intg-kpi-etiqueta">Vendido hoy</div>
          <div className="intg-kpi-valor">{entero(d.delDia.piezas)} pzs</div>
          <div className="intg-kpi-nota">{pesos(d.delDia.importe)} en precio de venta</div>
        </div>
        <div className="intg-kpi">
          <div className="intg-kpi-etiqueta">
            <span className="intg-punto" style={{ background: "var(--intg-full)" }} /> Full hoy
          </div>
          <div className="intg-kpi-valor">{entero(d.delDia.full)}</div>
          <div className="intg-kpi-nota">Surtido directo</div>
        </div>
        <div className="intg-kpi">
          <div className="intg-kpi-etiqueta">
            <span className="intg-punto" style={{ background: "var(--intg-drop)" }} /> Drop hoy
          </div>
          <div className="intg-kpi-valor">{entero(d.delDia.drop)}</div>
          <div className="intg-kpi-nota">{entero(d.delDia.cancelaciones)} pzs canceladas hoy</div>
        </div>
        <div className="intg-kpi">
          <div className="intg-kpi-etiqueta">Drop por surtir</div>
          <div className="intg-kpi-valor">{entero(d.drop.piezas)} pzs</div>
          <div className="intg-kpi-nota">
            {entero(d.drop.pedidos)} pedido(s) en <a href="/ListadoPendienteSurtir">Pendiente de Surtir</a>
          </div>
        </div>
        <button className="intg-kpi" onClick={() => irA(d.noCapturadas ? "pendientes" : "sinAlta")}>
          <div className="intg-kpi-etiqueta">
            <i className={porRevisar ? "fas fa-exclamation-triangle" : "fas fa-check-circle"} style={{ color: porRevisar ? "#d97706" : "#16a34a" }}></i> Por revisar
          </div>
          <div className="intg-kpi-valor">{entero(porRevisar)}</div>
          <div className="intg-kpi-nota">
            {entero(d.sinAlta.porDarDeAlta)} sin alta · {entero(d.noCapturadas)} ventas no capturadas
          </div>
        </button>
      </div>

      <div className="intg-dos">
        <div className="intg-caja">
          <h5>Piezas vendidas, ultimos 7 dias</h5>
          <div className="intg-caja-sub">Ventas registradas por dia de venta</div>
          <GraficaVentas serie={d.serie} />
        </div>
        <div className="intg-caja">
          <h5>Como trabaja la integracion</h5>
          <div className="intg-caja-sub">Siguiente corte {d.siguienteCorte} · cada 3 horas</div>
          <div className="intg-regla">
            <span className="intg-tipo">Ventas</span>
            <span className="intg-etq full">Full</span>
            <span className="intg-regla-accion">Surtido directo</span>
          </div>
          <div className="intg-regla">
            <span></span>
            <span className="intg-etq drop">Drop</span>
            <span className="intg-regla-accion">Pedido pendiente de surtir</span>
          </div>
          <div className="intg-regla">
            <span className="intg-tipo">Cancelaciones</span>
            <span className="intg-etq full">Full</span>
            <span className="intg-regla-accion">Actualiza pedido y surtido</span>
          </div>
          <div className="intg-regla">
            <span></span>
            <span className="intg-etq drop">Drop</span>
            <span className="intg-regla-accion">Actualiza el pedido</span>
          </div>
          <div className="intg-regla">
            <span className="intg-tipo">Inventario</span>
            <span className="intg-etq drop">Drop</span>
            <span className="intg-regla-accion">
              % de CEDIS cada hora; bajo el minimo se apaga.{" "}
              <b style={{ color: stock ? "#166534" : "#92400e" }}>{stock ? `Activo en ${stock} cuenta(s)` : "Apagado"}</b>
            </span>
          </div>
        </div>
      </div>

      <div className="intg-cuentas">
        {d.cuentas.map((c) => {
          const pct = c.publicaciones ? Math.round((c.amarradas / c.publicaciones) * 100) : 0;
          return (
            <div className="intg-tarjeta" key={c._id}>
              <div className="intg-tarjeta-cab">
                <b>{c.nombre}</b>
                <Badge color={colorEstado[c.estado] || "secondary"} pill title={c.ultimoError}>
                  {c.estado}
                </Badge>
              </div>
              <div className="intg-dato">
                <span>Modo</span>
                <span>{c.modo}</span>
              </div>
              <div className="intg-dato">
                <span>Vendido hoy</span>
                <span>{c.registrarVentas === "Si" ? `${entero(c.ventasHoy)} pzs` : "No registra ventas"}</span>
              </div>
              <div className="intg-dato">
                <span>Existencias</span>
                <span>
                  {c.modo === "Lectura y escritura" && c.sincronizaStock !== "No"
                    ? `${c.stockPorcentaje}% · min ${entero(c.stockMinimoCedis)} · ${c.sincronizaStock}`
                    : "Sin publicar"}
                </span>
              </div>
              <div className="intg-dato" style={{ marginTop: 4 }}>
                <span>Publicaciones amarradas</span>
                <span>
                  {entero(c.amarradas)} de {entero(c.publicaciones)}
                </span>
              </div>
              <div className="intg-medidor" title={`${pct}%`}>
                <div style={{ width: `${pct}%` }} />
              </div>
              {c.stockDesdeFull ? <div className="intg-aviso">Sus existencias salen del almacen Full; deben salir de CEDIS.</div> : null}
              {c.ultimoError ? <div className="intg-aviso">{c.ultimoError}</div> : null}
            </div>
          );
        })}
      </div>
    </>
  );
}

export default PanelMeli;
